/* ================= BOOT ================= */
(function(){
  const boot=document.getElementById('boot');
  if(!boot)return;
  const RM=matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(RM||sessionStorage.getItem('slpboot')){boot.remove();return;}
  sessionStorage.setItem('slpboot','1');
  const lis=boot.querySelectorAll('li');
  lis.forEach((li,i)=>setTimeout(()=>li.classList.add('on'),120+i*170));
  setTimeout(()=>boot.classList.add('done'),120+lis.length*170+420);
  setTimeout(()=>boot.remove(),120+lis.length*170+1100);
})();

/* ================= CFD SIM ================= */
(function(){
  const c=document.getElementById('sim');
  if(!c)return;
  const x=c.getContext('2d');
  const RM=matchMedia('(prefers-reduced-motion: reduce)').matches;
  let W,H,DPR;
  const off=document.createElement('canvas');
  const ox=off.getContext('2d');

  /* velocity colormap: blue → cyan → green → amber → red */
  const STOPS=[[45,107,255],[0,229,255],[61,255,162],[255,210,61],[255,61,90]];
  function vc(t,a){
    t=Math.max(0,Math.min(1,t));
    const n=STOPS.length-1,i=Math.min(n-1,Math.floor(t*n)),f=t*n-i;
    const s=STOPS[i],e=STOPS[i+1];
    return 'rgba('+Math.round(s[0]+(e[0]-s[0])*f)+','+Math.round(s[1]+(e[1]-s[1])*f)+','+Math.round(s[2]+(e[2]-s[2])*f)+','+a+')';
  }

  function bounds(){
    const cw=Math.min(W*0.46,640),ch=cw*0.27,cx=W*0.52,g=H*0.66;
    return{x0:cx-cw/2,x1:cx+cw/2,g,ch,cw};
  }
  /* coupe profile incl. rear wing plane */
  function topAt(px){
    const b=bounds();
    if(px<b.x0||px>b.x1)return null;
    const t=(px-b.x0)/b.cw;let h;
    if(t<0.16)h=0.22+t/0.16*0.16;
    else if(t<0.34)h=0.38+(t-0.16)/0.18*0.40;
    else if(t<0.60)h=0.78+Math.sin((t-0.34)/0.26*Math.PI)*0.10;
    else if(t<0.86)h=0.78-(t-0.60)/0.26*0.30;
    else if(t<0.93)h=0.48;
    else h=0.62;
    return b.g-b.ch*h;
  }

  /* wireframe car + grid pre-render (crisp layer drawn on top each frame) */
  function prerender(){
    off.width=W*DPR;off.height=H*DPR;
    ox.setTransform(DPR,0,0,DPR,0,0);
    ox.clearRect(0,0,W,H);
    const b=bounds();

    /* ground + echoes */
    ox.strokeStyle='rgba(135,175,220,.22)';ox.lineWidth=1;
    ox.beginPath();ox.moveTo(0,b.g);ox.lineTo(W,b.g);ox.stroke();
    ox.strokeStyle='rgba(135,175,220,.07)';
    for(let i=1;i<=4;i++){const y=b.g+i*i*4.5;ox.beginPath();ox.moveTo(0,y);ox.lineTo(W,y);ox.stroke();}

    /* mesh verticals through body */
    ox.strokeStyle='rgba(0,229,255,.10)';
    for(let i=1;i<16;i++){
      const px=b.x0+b.cw*i/16,ty=topAt(px);
      if(ty===null)continue;
      ox.beginPath();ox.moveTo(px,ty);ox.lineTo(px,b.g);ox.stroke();
    }

    /* outline */
    ox.strokeStyle='rgba(0,229,255,.85)';ox.lineWidth=1.6;
    ox.shadowColor='rgba(0,229,255,.55)';ox.shadowBlur=10;
    ox.beginPath();ox.moveTo(b.x0,b.g);
    for(let px=b.x0;px<=b.x1;px+=3)ox.lineTo(px,topAt(px));
    ox.lineTo(b.x1,b.g);ox.stroke();
    ox.shadowBlur=0;

    /* greenhouse line */
    ox.strokeStyle='rgba(0,229,255,.4)';ox.lineWidth=1;
    ox.beginPath();
    for(let t=0.30;t<=0.64;t+=0.01){
      const px=b.x0+b.cw*t,ty=topAt(px)+b.ch*0.14;
      t===0.30?ox.moveTo(px,ty):ox.lineTo(px,ty);
    }
    ox.stroke();

    /* wing strut */
    const wx=b.x0+b.cw*0.895;
    ox.beginPath();ox.moveTo(wx,topAt(wx));ox.lineTo(wx,topAt(b.x0+b.cw*0.7));ox.stroke();

    /* wheels: arc + spokes */
    const r=b.ch*0.30;
    [[b.x0+b.cw*0.22],[b.x0+b.cw*0.78]].forEach(([cx2])=>{
      ox.strokeStyle='rgba(0,229,255,.7)';ox.lineWidth=1.4;
      ox.beginPath();ox.arc(cx2,b.g,r,Math.PI,0);ox.stroke();
      ox.strokeStyle='rgba(0,229,255,.35)';ox.lineWidth=1;
      for(let a=0;a<6;a++){
        const ang=Math.PI+a*Math.PI/5;
        ox.beginPath();ox.moveTo(cx2,b.g);
        ox.lineTo(cx2+Math.cos(ang)*r*0.85,b.g+Math.sin(ang)*r*0.85);ox.stroke();
      }
    });

    /* node markers */
    ox.fillStyle='#00E5FF';ox.shadowColor='rgba(0,229,255,.9)';ox.shadowBlur=8;
    [0.0,0.16,0.47,0.86,0.93,1.0].forEach(t=>{
      const px=b.x0+b.cw*t,py=topAt(Math.min(px,b.x1-0.1))||b.g;
      ox.fillRect(px-2,py-2,4,4);
    });
    ox.shadowBlur=0;
  }

  /* particles */
  const P=[];
  function spawn(p,init){
    p.x=init?Math.random()*W:-15;
    p.y=H*0.14+Math.random()*(H*0.50);
    p.vb=1.4+Math.random()*1.7;
    p.life=0;p.max=420+Math.random()*320;
  }
  function syncParticles(){
    const target=RM?0:Math.round(Math.min(W,1500)/3.4);
    while(P.length<target){const p={};spawn(p,true);P.push(p);}
    if(P.length>target)P.length=target;
  }

  const VMIN=1.4,VMAX=7.6,LIFT=92;

  function staticRender(){
    for(let i=0;i<320;i++){
      const px=Math.random()*W;let py=H*0.14+Math.random()*(H*0.5);
      const top=topAt(px);
      let sp=2.2;
      if(top!==null){const gap=py-top;if(gap<LIFT){if(gap<2)py=top-4;const k=1-Math.max(py-top,2)/LIFT;sp=2.2*(1+1.7*Math.max(k,0));}}
      const t=(sp-VMIN)/(VMAX-VMIN);
      x.strokeStyle=vc(t,0.35);x.lineWidth=1;
      x.beginPath();x.moveTo(px,py);x.lineTo(px+9,py);x.stroke();
    }
    if(off.width&&off.height)x.drawImage(off,0,0,W,H);
  }

  /* size guard: never init at 0×0 — drawImage throws on a 0-size canvas */
  let ready=false;
  function resize(){
    DPR=Math.min(window.devicePixelRatio||1,2);
    W=c.clientWidth;H=c.clientHeight;
    if(!W||!H){ready=false;return;}
    c.width=W*DPR;c.height=H*DPR;
    x.setTransform(DPR,0,0,DPR,0,0);
    x.fillStyle='#070B14';x.fillRect(0,0,W,H);
    prerender();
    syncParticles();
    ready=true;
    if(RM)staticRender();
  }
  resize();
  window.addEventListener('resize',resize);
  window.addEventListener('load',resize);
  if('ResizeObserver' in window)new ResizeObserver(()=>resize()).observe(c);

  /* probe */
  let mx=-1,my=-1;
  c.addEventListener('mousemove',e=>{const r=c.getBoundingClientRect();mx=e.clientX-r.left;my=e.clientY-r.top;});
  c.addEventListener('mouseleave',()=>{mx=-1;my=-1;});

  /* scan sweep */
  let scanX=-1;
  if(!RM)setInterval(()=>{if(scanX<0)scanX=0;},7000);

  const hv=document.getElementById('hud-v'),hf=document.getElementById('hud-f');
  let tick=0;

  function frame(){
    if(!ready){requestAnimationFrame(frame);return;}
    /* trail persistence */
    x.fillStyle='rgba(7,11,20,0.26)';
    x.fillRect(0,0,W,H);

    const b=bounds();

    for(const p of P){
      const top=topAt(p.x);
      let vy=0,sp=p.vb;
      if(top!==null){
        let gap=p.y-top;
        if(gap<LIFT){
          if(gap<2){p.y=top-2;gap=2;}
          const k=1-gap/LIFT;
          vy=-k*4.4;
          sp=p.vb*(1+1.7*k);   /* Bernoulli: constriction = speed */
        }
      }else if(p.x>b.x1&&p.y<b.g-10){vy=0.55;}
      if(p.y>b.g-2)p.y=b.g-2;

      const px0=p.x,py0=p.y;
      p.x+=sp;p.y+=vy;p.life++;

      const fade=Math.min(p.life/36,1)*Math.min((p.max-p.life)/60,1);
      const t=(sp-VMIN)/(VMAX-VMIN);
      x.strokeStyle=vc(t,0.5*fade);
      x.lineWidth=0.5+t*1.4;
      x.beginPath();x.moveTo(px0-sp*3.2,py0-vy*3.2);x.lineTo(p.x,p.y);x.stroke();

      if(p.x>W+15||p.life>p.max)spawn(p,false);
    }

    /* crisp layer */
    if(off.width&&off.height)x.drawImage(off,0,0,W,H);

    /* scan sweep */
    if(scanX>=0){
      const g=x.createLinearGradient(scanX-60,0,scanX,0);
      g.addColorStop(0,'rgba(0,229,255,0)');g.addColorStop(1,'rgba(0,229,255,.22)');
      x.fillStyle=g;x.fillRect(scanX-60,0,60,H);
      x.fillStyle='rgba(0,229,255,.6)';x.fillRect(scanX,0,1.5,H);
      scanX+=W/40;if(scanX>W+60)scanX=-1;
    }

    /* probe crosshair */
    if(mx>=0){
      x.strokeStyle='rgba(0,229,255,.35)';x.lineWidth=1;
      x.beginPath();x.moveTo(mx,0);x.lineTo(mx,H);x.stroke();
      x.beginPath();x.moveTo(0,my);x.lineTo(W,my);x.stroke();
      const top=topAt(mx);
      let v=11.6+Math.sin(tick*0.05)*0.4;
      if(top!==null&&my<top&&top-my<LIFT)v+=(1-(top-my)/LIFT)*9.5;
      const s='PROBE '+v.toFixed(1)+' M/S';
      x.font='11px "Share Tech Mono"';
      const tw=x.measureText(s).width;
      x.fillStyle='rgba(4,6,11,.85)';x.fillRect(mx+12,my-26,tw+16,20);
      x.strokeStyle='rgba(0,229,255,.5)';x.strokeRect(mx+12,my-26,tw+16,20);
      x.fillStyle=vc(Math.min(1,(v-10)/12),1);x.fillText(s,mx+20,my-12);
    }

    if(++tick%30===0&&hv){
      hv.textContent=(11.8+Math.random()*1.5).toFixed(1);
      hf.textContent=Math.round(84+Math.random()*8);
    }
    if(!RM)requestAnimationFrame(frame);
  }

  if(!RM)frame();
})();

/* ================= REVEALS ================= */
(function(){
  const obs=new IntersectionObserver(es=>{
    es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');obs.unobserve(e.target);}});
  },{threshold:0.12});
  document.querySelectorAll('.reveal').forEach(el=>obs.observe(el));
})();
